import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';

import LoadingSpinner from 'components/ui/loading_spinner';

import { filter } from 'lodash';

export default class CopyContactRoleModal extends React.Component {
  static propTypes = {
    contactLabel: PropTypes.string,
    copyFromString: PropTypes.string,
    projectContactRoles: PropTypes.arrayOf(PropTypes.shape({
      contact: PropTypes.shape({
        email: PropTypes.string,
        name: PropTypes.string,
        phoneFormatted: PropTypes.string,
      }).isRequired,
      id: PropTypes.number,
      durationStart: PropTypes.string,
      durationEnd: PropTypes.string,
      relationshipLabel: PropTypes.string,
    })),
    saving: PropTypes.bool,
    show: PropTypes.bool,
    onAddContactRoles: PropTypes.func,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    contactLabel: 'Contact',
    copyFromString: 'project'
  }

  state = {
    selectedIds: {}
  }

  isSelected(contactRole) {
    return this.state.selectedIds[contactRole.id.toString()] !== false;
  }

  handleChange = (event) => {
    const contactRoleId = event.target.name;
    const checked = event.target.checked;

    this.setState(state => ({
      selectedIds: {
        ...state.selectedIds,
        [contactRoleId.toString()]: checked
      }
    }));
  }

  handleCopy = () => {
    const selectedContactRoles = filter(
      this.props.projectContactRoles,
      contactRole => this.isSelected(contactRole)
    ).map(contactRole => ({
      ...contactRole,
      id: null,
      contactUrl: null,
    }));

    this.props.onAddContactRoles(selectedContactRoles);
    this.props.onClose();
  }

  render() {
    return (
      <Modal
        backdrop="static"
        className="form-modal"
        show={this.props.show}
        onCancel={this.props.onClose}
        onHide={this.props.onClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Select {this.props.contactLabel}s to copy from {this.props.copyFromString}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this.renderContactsTable()}
        </Modal.Body>

        <Modal.Footer>
          {this.renderControls()}
        </Modal.Footer>
      </Modal>
    );
  }

  renderContactsTable() {
    return (
      <table className="table" name="contacts-table">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Company</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Relation</th>
          </tr>
        </thead>

        <tbody>
          {this.renderContactRows()}
        </tbody>
      </table>
    );
  }

  renderContactRows = () => {
    return this.props.projectContactRoles?.map(this.renderRow) || [];
  }


  renderRow = (contactRole, index) => {
    const { contact, relationshipLabel } = contactRole;

    return (
      <tr key={index} name="contactRoleRows">
        <td>
          <input
            checked={this.isSelected(contactRole)}
            name={contactRole.id}
            type="checkbox"
            onChange={this.handleChange}
          />
        </td>
        {contact.contactType === 'Contacts::Company' ? (
          <React.Fragment>
            <td />
            <td name="contactName">{contact.name}</td>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <td name="contactName">{contact.name}</td>
            <td>{contact.companyName || contact.businessName || ''}</td>
          </React.Fragment>
        )}
        <td name="contactEmail">
          <a href={`mailto:${contact.email}`}>
            {contact.email}
          </a>
        </td>
        <td name="contactPhoneFormatted">{contact.phoneFormatted}</td>
        <td name="contactRelationshipLabel">{relationshipLabel}</td>
      </tr>
    );
  }

  renderControls() {
    if (this.props.saving) {
      return <LoadingSpinner flex size="md" skipTopBuffer />;
    }

    return <React.Fragment>
      <button
        className="btn btn-ghost"
        name="cancel"
        onClick={this.props.onClose}
      >
        Cancel
      </button>
      <button
        className="btn btn-primary"
        name="copy"
        onClick={this.handleCopy}
      >
        Copy
      </button>
    </React.Fragment>;
  }
}
